import e from "@dialpad/dialtone-tokens/layered/themes/tokens-113-colors.css?inline";
//#region themes/113.js
var t = { brand: {
	css: e,
	name: "113"
} };
//#endregion
export { t as default };
